import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, image }) {
  const siteName = "Lane4 Sports Services";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - E-Tickets, Custom Medals & Event Management`;
  const desc = description || "Premium e-ticketing, custom medals, and event management for track & field. Trusted by 500+ coaches and organizers across the Southeast.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}
